module.exports = __webpack_public_path__ + "static/media/feedback-2.123f5132.svg";